import { render, staticRenderFns } from "./SubIdPerformance.vue?vue&type=template&id=13e9e128&"
import script from "./SubIdPerformance.vue?vue&type=script&lang=js&"
export * from "./SubIdPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports